import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

function Privacy() {
  return (
    <main className="privacy policy-page">
      <div className="policy-container">
        <p className="policy-updated">Last updated: 7 September 2026</p>
        <h1 className="policy-title">Privacy Policy</h1>
        <div className="policy-content">
          <p>This policy explains how Uightparcel handles personal information when you visit uightparcel.shop or contact us. Uightparcel is the operator responsible for the processing described here.</p>

          <h2>Current store status</h2>
          <p>This website is currently a catalogue preview. Online payment and order submission are not enabled. We do not ask for, process or store card numbers, expiry dates or security codes on this website.</p>

          <h2>Information we handle</h2>
          <ul>
            <li><strong>Information you choose to send:</strong> if you email us, we receive your email address and the content of your message through your email provider.</li>
            <li><strong>Selection data:</strong> product IDs, sizes, colours and quantities may be saved in your browser so your selection persists.</li>
            <li><strong>Notice preference:</strong> your browser may save that you dismissed the cookie notice.</li>
            <li><strong>Technical data:</strong> our hosting provider may process IP address, browser type, device information, timestamps and request logs to deliver and protect the site.</li>
          </ul>

          <h2>Why we use information</h2>
          <ul>
            <li>To display the website and maintain its security and reliability.</li>
            <li>To remember your selection and notice preference on your device.</li>
            <li>To respond when you contact us.</li>
            <li>To comply with law and establish, exercise or defend legal claims.</li>
          </ul>
          <p>Depending on where you live, our legal bases may include providing a service you request, our legitimate interests in operating and securing the site, your consent, and compliance with legal obligations.</p>

          <h2>Sharing and service providers</h2>
          <p>We do not sell personal information. Information may be handled by service providers that support site hosting, security and email delivery, or disclosed where required by law. These providers may process information only for the relevant service and under their own applicable terms.</p>

          <h2>International transfers</h2>
          <p>Service providers may process information in countries other than your own. Where required, appropriate safeguards should be used for international transfers. Contact us for information relevant to your location.</p>

          <h2>Retention</h2>
          <p>Browser selection data remains on your device until you clear it or remove the items. Email correspondence is kept only as long as reasonably needed to answer the enquiry, maintain appropriate records or meet legal requirements. Hosting logs are retained according to the hosting provider’s security and operational schedule.</p>

          <h2>Your choices and rights</h2>
          <p>Depending on your location, you may have rights to access, correct, delete, restrict or object to processing, withdraw consent, and receive a portable copy of certain information. You may also complain to your local data protection authority. To make a request, email us; we may need to verify your identity.</p>

          <h2>Children</h2>
          <p>This site is not directed to children, and we do not knowingly collect personal information from children through the website.</p>

          <h2>Security</h2>
          <p>We use reasonable organisational and technical safeguards, but no internet service is completely secure. Do not send payment credentials, passwords or other sensitive information by email.</p>

          <h2>Cookies and browser storage</h2>
          <p>We do not currently use advertising or analytics cookies. For a list of browser storage used by the site, see our <Link to="/cookies">Cookie Notice</Link>.</p>

          <h2>Changes</h2>
          <p>We may update this policy when the site or our practices change. The date above shows the latest revision. Material changes should be highlighted on the site.</p>

          <h2>Contact</h2>
          <p>For privacy questions or requests, email <a href="mailto:track@uightparcel.shop?subject=Privacy%20request">track@uightparcel.shop</a>.</p>
        </div>
      </div>
    </main>
  );
}

export default Privacy;
